import {LoadAsset} from './LoadAsset.class';
import {LoadAssetGroup} from './LoadAssetGroup.class';

export class PreloadChapterAssetGroup extends LoadAssetGroup {
  public chapterId;
  constructor({
    chapterId,
    loadAssetList,
  }: {
    chapterId: number;
    loadAssetList: LoadAsset[];
  }) {
    super({type: 'PreloadChapter', loadAssetList});

    this.chapterId = chapterId;
  }
}
